"use client";

import type { SessionUIContextValue } from "./session-ui-context";

/**
 * Result of a navigate-to-reference call. Callers use this to distinguish real
 * navigation from a redundant click on the already-current target.
 */
export enum NavigationOutcome {
  /** Real navigation occurred and state changes were dispatched. */
  Navigated = "navigated",
  /** Target equals current UI state, so there is nothing to do. */
  Noop = "noop",
  /** Short-id was malformed or did not match a known entity. */
  Unresolved = "unresolved",
}

export type ReferenceNavigationHandler = (
  shortId: string | null | undefined,
) => NavigationOutcome;

export interface ReferenceNavigationApi {
  navigateToProductReference: ReferenceNavigationHandler;
  navigateToVersionReference: ReferenceNavigationHandler;
  navigateToFileReference: ReferenceNavigationHandler;
  navigateToCollabReference: ReferenceNavigationHandler;
  setBeforeNavigate: (handler: (() => void) | null) => void;
  setAfterCollabNavigate: SessionUIContextValue["setAfterCollabNavigate"];
  setOpenFilePreview: SessionUIContextValue["setOpenFilePreview"];
}
